import { useFlag } from '@calendly/feature-check-react'
import { useSelector } from 'react-redux'

import { isAdminOrOwnerSelector } from 'selectors/current_user'

export const SETTINGS_MODAL_AI_TAB = Object.freeze({
  CALLIE: 'callie',
  NOTETAKER: 'notetaker',
  NOTETAKER_ACCESS: 'notetaker_access',
})

const SETTINGS_MODAL_AI_TABS = Object.freeze([
  { slug: SETTINGS_MODAL_AI_TAB.CALLIE },
  { slug: SETTINGS_MODAL_AI_TAB.NOTETAKER },
  { slug: SETTINGS_MODAL_AI_TAB.NOTETAKER_ACCESS },
])

export function getSettingsModalAiTabs({ showAdminNotetakerAccessTab = false } = {}) {
  return SETTINGS_MODAL_AI_TABS.filter(({ slug }) => (
    slug !== SETTINGS_MODAL_AI_TAB.NOTETAKER_ACCESS || showAdminNotetakerAccessTab
  ))
}

export function normalizeSettingsModalAiTab(tab, ctx) {
  return getSettingsModalAiTabs(ctx).some(({ slug }) => slug === tab)
    ? tab
    : SETTINGS_MODAL_AI_TAB.CALLIE
}

export function useShowSettingsModalAdminNotetakerAccess() {
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)
  const isNotetakerAdminSettingsPageEnabled = useFlag('notetaker_admin_settings_page')

  return isOwnerOrAdmin && isNotetakerAdminSettingsPageEnabled
}
